import { createAction, createSlice } from "@reduxjs/toolkit";

const getAllCloseCaptionSlice = createSlice({
  name: "getAllCloseCaption",
  initialState: { data: [], processing: false },
  reducers: {
    pending(state, action) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.data = action.payload.data;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state, action) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = getAllCloseCaptionSlice;
const getAllCloseCaptionAction = createAction(name);

export {
  getAllCloseCaptionAction,
  actions as getAllCloseCaptionActions,
  reducer as getAllCloseCaptionReducer,
};
